// import { Form } from 'element-ui'
import router from './router'
import store from './store'

import { getToken } from '@/utils/auth'

// 自由登录白名单

const whiteList = ['/Login', '/', '/Index', '/Brand', '/Faster', '/Goods', '/Register', '/Forget', '/GoodsDetail', '/Ppxq', '/Search', '/News', '/NewsDetail', '/About', '/Supplier', '/Honor', '/Hotcake', '/Statistics', '/Scenearea', '/Flashsale', '/Scenehall', '/Help', '/Password', '/Agreement', '/Privacy', '/Complaint', '/Placeorder', '/Howinqu', '/Howpay', '/Orderprogress', '/Exportprint', '/Pricedesc', '/Returngoods', '/Freight', '/Shiptime', '/Inspection', '/Bill', '/Addressmanag', '/Contactus', '/LedIntroduce', '/Resources', '/IndustryList', '/InfoList', '/InfoDetail', '/Sitemap', '/SearchList', '/Classify', '/Quotationsd', '/Repair', '/RepairDetail', '/Energy', '/Interthings', '/Dynamic', '/DynamicDate', '/Digital', '/DeepSeek']

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()
  if (hasToken && to.path !== '/Bindtel') {
    if (to.path === '/Login') {
      // 如果路径是login 且已经登录 跳转到home
      next({ path: '/' })
    } else {
      await store.dispatch('user/getInfo')
      next()
    }
  } else if (hasToken && to.path === '/Bindtel') {
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在自由登录白名单中直接登录
      next()
    } else {
      next({ path: '/Login' })
    }
  }
//   next({ ...to, replace: true })
})

// console.info(hasToken)



// WEBPACK FOOTER //
// ./src/permission.js